__turbopack_context__.v({
  "className": "outfit_c96defa3-module__FRyvMq__className",
  "variable": "outfit_c96defa3-module__FRyvMq__variable",
});
